import { render, staticRenderFns } from "./BackComNews.vue?vue&type=template&id=f83e14be&scoped=true"
import script from "./BackComNews.vue?vue&type=script&lang=js"
export * from "./BackComNews.vue?vue&type=script&lang=js"
import style0 from "./BackComNews.vue?vue&type=style&index=0&id=f83e14be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83e14be",
  null
  
)

export default component.exports